/**
 * Input box Component
 */
export * from './form-validator';
